enum SecurityScoreEnum {
  VeryWeak = 20,
  Weak = 40,
  Medium = 60,
  Strong = 80,
  VeryStrong = 100,
}

export default SecurityScoreEnum;
